import { StyleSheet } from '@react-pdf/renderer';
import { UNIT } from '../../constants';

export const styles = StyleSheet.create({
  title: {
    fontSize: 1.625 * UNIT,
    textAlign: 'center',
    marginBottom: UNIT * 1.5
  },
  rightPart: { width: '38%', marginHorizontal: UNIT * 0.375 },
  leftPart: { width: '60%' },
  tableau: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: 1.5 * UNIT,
    paddingHorizontal: 0.625 * UNIT,
    alignItems: 'center'
  },
  underTab: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: 2.1875 * UNIT,
    paddingHorizontal: 0.625 * UNIT,
    alignItems: 'center'
  },
  separator: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    height: UNIT * 0.125,
    paddingHorizontal: 0.625 * UNIT
  },
  border: {
    borderBottom: '1 solid grey',
    marginBottom: UNIT * 0.3125,
    paddingBottom: UNIT * 0.5
  },
  topBorder: {
    borderTop: '1 solid grey',
    marginBottom: 0.9375 * UNIT,
    paddingTop: 0.5 * UNIT
  },
  labelTab: {
    fontSize: 0.625 * UNIT
  },
  positionRow: {
    display: 'flex',
    flexDirection: 'row'
  }
});
